import * as React from 'react';
import { ReactNode } from 'react';
import Footer from './Footer';
import Header from './Header';

interface Props {
  children?: any;
}

export function BaseLayout(props: Props): ReactNode {

  return (
    <div className={`min-h-screen flex flex-column`}>
      <Header/>
      <div>
        <>{props.children}</>
      </div>
      <div className={'mt-auto'}><Footer/></div>
    </div>
  );
}
